<template>

    <div class="panel-body">

        <export :settings="settings" :model="model"></export>

        <component :is="model" :query="query" v-on:search="triggerSearch" :loading="loading"
                   :searchbar-data="searchbarData" keep-alive></component>

        <div class="list-group-root" style="min-height:300px;">

            <div class="list-group-item list-header">

                <div class="row">

                    <div v-if="settings.foldout == true" class="col-xs-1"></div>

                    <div v-for="(setting, key) in settings.tableFields" v-bind:class="[setting.class, orderClass(key)]">

	                <span v-if="setting.sortable == true" v-on:click="sort(key)" class="sortable">
	                    {{ setting.text }}
	                    <span v-if="orderClass(key) == 'asc'"><li class="fa fa-sort-amount-asc"></li></span>
	                	<span v-else-if="orderClass(key) == 'desc'"><li class="fa fa-sort-amount-desc"></li></span>
	                	<span v-else><i class="fa fa-sort" aria-hidden="true"></i></span>
	                </span>
                        <span v-else>
	                    {{ setting.text }}
	                </span>

                    </div>

                    <div v-for="(textArea, key) in settings.textAreas" v-bind:class="textArea.class">

                	<span>
	                    {{ textArea.text }}
	                </span>

                    </div>

                </div>

            </div>

            <div class="list-no-hits" v-if="pagination.numItems == 0 && loading == false">
                Inga träffar
            </div>

            <div class="list-group">

                <div class="list-group-item" v-for="item in items">

                    <div class="row">

                        <div v-if="settings.foldout == true" class="col-xs-1" v-bind:href="'#item-'+item.id"
                             data-toggle="collapse">
                            <li class="fa fa-chevron-down"></li>
                        </div>

                        <div v-for="(col, key) in settings.tableFields" v-bind:class="col.class"
                             v-html="colValue(item, key)">

                        </div>

                        <div v-for="(textArea, key) in settings.textAreas" v-bind:class="textArea.class">

                            <textarea class="w-100" style="width:100%; background-color: #fffef3; min-height: 70px;"
                                      v-on:keyup="textareaSave(textArea, item, $event.target.value)">{{ item.comment }}</textarea>

                        </div>

                        <div v-for="(link, key) in settings.links" v-bind:class="link.class">
                            <a v-if="link.type == 'url'" v-bind:href="link.action+''+item.id"
                               class="btn btn-xs btn-default list-btn">{{ key }}</a>

                            <a v-if="link.type == 'function'" v-on:click="itemClick(link, item)"
                               class="btn btn-xs btn-default list-btn">{{ key }}</a>
                        </div>

                    </div>

                    <div v-if="settings.foldout == true" class="list-group collapse" v-bind:id="'item-'+item.id"
                         style="margin-bottom: 0px;">

                        <component :is="foldoutComponent" :item="item" :settings="settings" keep-alive></component>

                    </div>

                </div>

            </div>

        </div>

        <div style="text-align: right;">

            <div style="float:left; text-align:left; margin-top:22px; color:#999;">

                {{ pagination.numItems }} träffar av {{ pagination.totalItems }} poster

            </div>

            <ul class="pagination pagination-sm">
                <li class="text prev" v-if="pagination.activePage != 1" v-on:click="paginate('prev')">
                    <span style="cursor: pointer;"><i class="fa fa-angle-double-left"
                                                      aria-hidden="true"></i> Previous</span>
                </li>
                <li v-bind:class="{ active: pagination.activePage==n+1 }" v-on:click="paginate(n+1)"
                    v-for="n in pagination.limitNumPages">
                    <span style="cursor: pointer;">{{ n + 1 }}</span>
                </li>
                <li class="text next" v-if="pagination.activePage != pagination.numPages" v-on:click="paginate('next')">
                    <span style="cursor: pointer;">Next <i class="fa fa-angle-double-right"
                                                           aria-hidden="true"></i></span>
                </li>
            </ul>

        </div>

    </div>

    </div>

</template>

<script>

window._ = require('lodash')

// import customFunction from './templates/import-methods'

Vue.component('export', require('./Export.vue').default)

require('./templates/import-components')
require('./templates/import-methods')

export default {
    mounted () {
        console.log('search bar munted ready.')

        let listheaderpos = $('.list-header').offset().top

        $(window).resize(function () {
            listheaderpos = $('.list-header').offset().top
        })

        $(window).scroll(function () {
            /* List header static */

            if ($(window).scrollTop() > listheaderpos) {
                if (!$('.list-header').hasClass('static')) {
                    $('.list-header').addClass('static')
                    $('.list-group-root').css('margin-top', '60px')
                }
            }

            if ($(window).scrollTop() < listheaderpos) {
                if ($('.list-header').hasClass('static')) {
                    $('.list-header').removeClass('static')
                    $('.list-group-root').css('margin-top', '0')
                }
            }
        })
    },

    props: {
        model: {
            required: true
        },
        searchbarData: {}
    },

    data: function () {
        return {

            route: '',
            foldoutComponent: '',

            query: {},
            searchParams: {},
            items: [],
            settings: [],
            loading: true,

            orderField: null,
            orderBy: null,

            pagination: {

                numPages: 0,
                numItems: 0,
                numItemsShow: 0,
                limitNumPages: '',
                totalItems: 0

            }
        }
    },

    watch: {

        settings: function () {
            if (!this.orderField) {
                console.log('no orderby')

                this.orderField = Object.keys(this.settings.tableFields)[0]
            }

            if (!this.orderBy) {
                this.orderBy = 'desc'
            }
        }

    },

    created: function () {
        this.getData(true)
    },

    methods: {

        sort: require('./methods/sort'),

        triggerSearch: function (query) {
            this.query = query

            console.log('trigger search')
            this.loading = 1
            this.search()
        },

        search: _.debounce(
            require('./methods/search'), 500
        ),

        paginate: require('./methods/set-pagination'),

        getData: require('./methods/get-data'),

        limitNumPages: require('./methods/limit-pagination'),

        dotArrayToObject: function (item, key) {
            // var toObject = key.split('.').reduce((o,i)=> o[i], item)

            const splited = key.split('.')

            const reduced = splited.reduce(function (o, i) {
                if (o) {
                    return o[i]
                }
            }, item)

            // console.log('to object result');
            // console.log(reduced);

            return reduced
        },

        colValue: function (item, key) {
            const self = this

            const s = self.settings.tableFields[key]

            const colName = self.dotArrayToObject(item, key)

            if (!colName) {
                return null
            }

            if (s.checkbox) {
                if (colName == 1) {
                    return '<img src="/images/check.png" style="width:22px;" />'
                }

                return null
            }

            if (s.link) {
                if (typeof (s.fields) === 'object') {
                    var url = []

                    Object.keys(s.fields).forEach(function (urlKey) {
                        // console.log(s.fields[urlKey]);

                        url.push(urlKey + '=' + self.dotArrayToObject(item, s.fields[urlKey]))
                    })

                    var url = '?' + url.join('&')
                } else {
                    var url = self.dotArrayToObject(item, s.fields)
                }

                return '<a href="' + s.link + '' + url + '">' + colName + '</a>'
            }

            if (s.suffix) {
                return colName + '' + s.suffix
            }

            return colName
        },

        itemClick: function (link, item) {
            customFunction[this.model][link.action](this, item)
        },

        textareaSave: function (textarea, item, text) {
            customFunction[this.model][textarea.action](this, item, text)
        },

        orderClass: function (key) {
            // console.log('setting key '+key);

            if (this.orderField == key) {
                return this.orderBy
            }

            return null
        }

    }

}
</script>
